import React from 'react';

const DocumentName = ({ 
  isDoc1, 
  data, 
  comparisonID, 
  setDoc1Name, 
  setDoc2Name, 
  doc1Name, 
  doc2Name 
}) => {
  const handleNameChange = async () => {
    const fieldName = "doc1_name";
    const currentName = data?.doc1_name;
    const newName = window.prompt(`Enter a new name for ${fieldName}:`, currentName || "Unnamed");
    
    if (newName !== null && newName.trim() !== "") {
      try {
        const claimId = comparisonID; 
        if (!claimId) {
          console.error("ERROR: Claim ID is missing!");
          alert("Error: Claim ID is missing.");
          return;
        }
        
        const requestBody = JSON.stringify({ [fieldName]: newName });
        const response = await fetch(`${process.env.REACT_APP_DOCNAMES}/${claimId}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: requestBody,
        });
        
        const result = await response.json();
        if (!response.ok) {
          throw new Error(result.error || "Failed to update the database");
        }
        
        alert(`${fieldName} updated successfully!`);

        setDoc1Name(newName);
        
      } catch (error) {
        console.error("ERROR:", error);
        alert("Failed to update the database. Please try again.");
      }
    }
  };

  return (
    <span
      style={{
        cursor: "pointer",
        color: "#00B3B5",
        textDecoration: "underline",
        zIndex: "1000",
      }}
      className={"doc1"}
      onClick={handleNameChange}
    >
      {doc1Name || "Unnamed"}
    </span>
  );
};

export default DocumentName;
